import { RefObject } from 'react'
import type { SearchItemType, SubmitItemType, OnSubmit } from '../../types'
import { DepartmentType, getDepartmentByName } from '../../departmentMap'

export const createHandleSubmit = ({
  searchInput,
  activeDepartment,
  items,
  onSubmit,
  handleInputFocus,
  closeSearch,
  searchDepartment,
}: {
  searchInput: RefObject<HTMLInputElement | null>
  activeDepartment: DepartmentType
  items: Array<{ department: { enum: string } }>
  onSubmit: OnSubmit
  handleInputFocus: (searchOpen: boolean) => void
  closeSearch: () => void
  searchDepartment: {
    name: string
    title: string
  }
}) => {
  return (submitItem: SubmitItemType) => {
    const normalisedSearchDept =
      activeDepartment.name === 'all'
        ? searchDepartment.name
        : activeDepartment.name
    const selectedDepartment =
      activeDepartment.name === 'all'
        ? getDepartmentByName(
            normalisedSearchDept || /* istanbul ignore next */ 'all_cards',
          )
        : activeDepartment

    const itemWithDepartment = {
      ...submitItem,
      department: {
        name: selectedDepartment.name,
        title: selectedDepartment.title,
        activeDepartment: {
          name: activeDepartment.name,
          enum: activeDepartment.enum,
        },
        numberOfItems:
          activeDepartment.name === 'all'
            ? items.length
            : items.filter(
                suggestion =>
                  suggestion.department.enum === activeDepartment.enum,
              ).length,
      },
    }

    onSubmit(itemWithDepartment as SearchItemType)

    if (searchInput.current) {
      searchInput.current.blur()
      handleInputFocus(false)
      closeSearch()
    }
  }
}
